import { render } from "./organisation-details.vue?vue&type=template&id=7be3d128"
import script from "./organisation-details.vue?vue&type=script&lang=js"
export * from "./organisation-details.vue?vue&type=script&lang=js"

import "./organisation-details.vue?vue&type=style&index=0&id=7be3d128&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__